import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import { FC, useEffect, useState } from 'react'
import { Form as FinalForm } from 'react-final-form'
import SearchExpertisesResults from '../component/web/expertises/SearchExpertisesResults'
import SearchExpertises from '../component/web/expertises/SearchExpertises'
import SearchAccordion from '../control/accordion/SearchAccordion'
import useTranslate from '../i18n/useTranslate'
import useExpertises from '../component/web/shareLogic/useExpertises'
import useLoading from '../control/loading/useLoading'
import { SearchExpertisesLUT } from '../services/web/types/responseWebServiceTypes'

const ManageExpertises: FC<{}> = () => {
    const initialFormValues = {
        keyword: '',
    }
    const [searchResult, setSearchResult] = useState<SearchExpertisesLUT[]>([])
    const translate = useTranslate()
    const expertisesHook = useExpertises()
    const loadingHook = useLoading()

    const submitSearch = async (values: Record<string, any>) => {
        loadingHook.loadingOpen()
        const result: SearchExpertisesLUT[] = await handleSearch(values.keyword)
        loadingHook.loadingClose()
        setSearchResult(result ?? [])
    }

    const handleSearch = (keyword: string | null) => {
        return expertisesHook.searchExpertisesLUT(keyword)
    }

    useEffect(() => {
        loadingHook.loadingOpen()
        handleSearch(null)
            .then((data) => {
                setSearchResult(data)
            })
            .finally(() => {
                loadingHook.loadingClose()
            })
    }, [])

    return (
        <Container maxWidth="lg">
            <FinalForm
                onSubmit={submitSearch}
                initialValues={initialFormValues}
            >
                {() => {
                    return (
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <SearchAccordion title={translate.get('LABEL.MANAGE_EXPERTISES')}>
                                    <SearchExpertises />
                                </SearchAccordion>
                            </Grid>
                            <Grid item xs={12}>
                                <SearchExpertisesResults searchResult={searchResult} />
                            </Grid>
                        </Grid>
                    )
                }}
            </FinalForm>
        </Container>
    )
}

export default ManageExpertises
